import { otsBaseApi } from "../../ots-api";
import { ServiceTypeRule, ServiceTypeRuleEntity } from "../../../model/service-type-rule";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({ addTagTypes: ["ServiceTypeRules"] });

const serviceTypeRuleApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllServiceTypeRules: builder.query<ServiceTypeRule[], string>({
      query: (regionId) => ({
        url: `/service-type-rules/all`,
        method: 'GET',
        params: { regionId: regionId },
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(
              ({ id }) => ({ type: 'ServiceTypeRules', id } as const)
            ),
            { type: 'ServiceTypeRules', id: 'LIST' },
          ];
        } else {
          return [{ type: 'ServiceTypeRules', id: 'LIST' }];
        }
      },
    }),
    getServiceTypeRule: builder.query<ServiceTypeRule, string>({
      query: (id) => ({
        url: `/service-type-rules/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'ServiceTypeRules', id }],
    }),
    createServiceTypeRule: builder.mutation<
      ServiceTypeRule,
      ServiceTypeRuleEntity
    >({
      query: (rule) => ({
        url: '/service-type-rules',
        method: 'POST',
        body: rule.toTypeValue(),
      }),
      invalidatesTags: [{ type: 'ServiceTypeRules', id: 'LIST' }],
    }),
    updateServiceTypeRule: builder.mutation<
      ServiceTypeRule,
      ServiceTypeRuleEntity
    >({
      query: (rule) => ({
        url: '/service-type-rules',
        method: 'PUT',
        body: rule.toTypeValue(),
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'ServiceTypeRules', id },
      ],
    }),
    deleteServiceTypeRule: builder.mutation<void, ServiceTypeRuleEntity>({
      query: (rule) => ({
        url: '/service-type-rules',
        method: 'DELETE',
        body: rule.toTypeValue(),
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'ServiceTypeRules', id },
      ],
    }),
  }),
})

export const {
  useGetAllServiceTypeRulesQuery,
  useLazyGetAllServiceTypeRulesQuery,
  useGetServiceTypeRuleQuery,
  useCreateServiceTypeRuleMutation,
  useUpdateServiceTypeRuleMutation,
  useDeleteServiceTypeRuleMutation,
} = serviceTypeRuleApi;
